module.exports = __webpack_public_path__ + "img/derive.83afbb74.png";